import * as React from "react";
import { cn } from "@/shared/lib/utils";

import HouseDownloadWhiteIcon from "@/assets/icons/house/houseDownloadWhite.svg?react";
import HouseSearchWhiteIcon from "@/assets/icons/house/houseSearchWhite.svg?react";

type ButtonIconType = 'download' | 'search';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    iconType?: ButtonIconType,
}

const iconStyles = "transition-transform duration-200 ease-out"

const Button = React.forwardRef<HTMLButtonElement, IButtonProps>(
    ({ children, className, iconType, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "px-[16px] font-manrope h-[42px] bg-blue text-white !leading-none flex items-center gap-[10px] rounded-full shadow-[0px_4px_10px_0px_#00000033] backdrop-blur-md",
                    iconType? 'pl-0': 'py-[20px]',
                    className
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseLeave={()=>setPressed(false)}
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >
                {
                    iconType
                    ? 
                        <div className={cn(
                                'bg-blue h-full px-[20px] flex justify-center items-center rounded-full',
                            )}
                        >
                            {
                                iconType == 'download'? <HouseDownloadWhiteIcon className={cn(
                                    "w-[16px] h-[18px]",
                                    iconStyles, pressed && "w-[14px] h-[16px]"
                                )}/>
                                : <HouseSearchWhiteIcon className={cn(
                                    "w-[21px] h-[18px]",
                                    iconStyles, pressed && "w-[16px] h-[14px]"
                                )}/>
                            }
                        </div>
                    : null
                }
                {children}
            </button>
        );
    }
);

Button.displayName = "Button";

export default Button;
